import clsx from 'clsx'

import PointText from '@/components/view/atoms/text/PointText'
import Text, { TextColor } from '@/components/view/atoms/text/Text'
import AiInsideArea from '@/components/view/layouts/area/AiInsideArea'

import GeoSection from './GeoSection'

// positive=良い側（青）／negative=課題側（赤）
export type InsightTone = 'positive' | 'negative'

export interface InsightBlock {
  title: string
  tone: InsightTone
  // 箇条書きで示す内容。1件だけの場合も配列で渡す
  texts: string[]
}

interface Props {
  blocks: InsightBlock[]
  // AIによる改善案（無ければ省略）
  recommendation?: string | null
}

// 見出し帯付きのインサイトボックス（強み/弱みなど、良い側・課題側の対比に使う）
export const InsightBox = ({ block }: { block: InsightBlock }) => (
  <div
    className={clsx(
      'flex flex-col overflow-hidden',
      block.tone === 'positive' ? 'bg-info' : 'bg-critical',
      block.tone === 'positive' ? 'rounded-l-xl' : 'rounded-r-xl'
    )}
  >
    <div className='px-4 py-2 text-center'>
      <Text
        size={12}
        weight='bold'
        color={block.tone === 'positive' ? TextColor.INFO : TextColor.CRITICAL}
      >
        {block.title}
      </Text>
    </div>
    <div className={clsx('bg-surface m-2 mt-0 flex-1 rounded-lg px-4 py-3')}>
      <PointText texts={block.texts} />
    </div>
  </div>
)

// GEO/LLMO分析結果のインサイト（良い側・課題側の2カラム＋AIの改善案）
const GeoInsightsPanel = ({ blocks, recommendation }: Props) => (
  <GeoSection title='インサイト'>
    <div className='flex flex-col gap-3'>
      {blocks.length > 0 && (
        <div className='grid grid-cols-1 gap-1 md:grid-cols-2'>
          {blocks.map((block) => (
            <InsightBox key={block.title} block={block} />
          ))}
        </div>
      )}
      {recommendation && (
        <AiInsideArea>
          <div className='flex flex-col gap-1 p-2'>
            <div>
              <Text size={12} color={TextColor.AI} weight='bold'>
                改善案
              </Text>
            </div>
            <Text size={12} lineHeight={150}>
              {recommendation}
            </Text>
          </div>
        </AiInsideArea>
      )}
    </div>
  </GeoSection>
)

export default GeoInsightsPanel
